import {
  getFormValue,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

export function countryOfOriginChange(
  countryOfOriginQuestionKey: FieldsEnum,
  passportQuestionKey: FieldsEnum,
  peselQuestionKey: FieldsEnum,
  formName: FormsEnum
) {
  const isCountryOfOriginOtherThanPoland =
    getFormValue(countryOfOriginQuestionKey, formName) !== 'PL';

  setQuestionVisibility({
    key: passportQuestionKey,
    visible: isCountryOfOriginOtherThanPoland,
    formName,
  });

  setQuestionVisibility({
    key: peselQuestionKey,
    visible: !isCountryOfOriginOtherThanPoland,
    formName,
  });
}
